const ONBOARDING_SOURCE_KEY = 'onboarding_return_source'

export const persistOnboardingSource = (source?: string) => {
  const trimmed = source?.trim()
  if (trimmed) {
    sessionStorage.setItem(ONBOARDING_SOURCE_KEY, trimmed)
  }
}

/** Prefer ?source= query, then the value persisted for this onboarding session. */
export const resolveOnboardingSource = (querySource?: string | null): string | undefined => {
  const fromQuery = querySource?.trim()
  if (fromQuery) return fromQuery
  return sessionStorage.getItem(ONBOARDING_SOURCE_KEY)?.trim() || undefined
}

export const getLogoutRedirectUrl = (): string => {
  const pathname = window.location.pathname
  const querySource = new URLSearchParams(window.location.search).get('source')?.trim()
  const storedSource = sessionStorage.getItem(ONBOARDING_SOURCE_KEY)?.trim()
  const isOnboardingPage = pathname === '/onboarding' || pathname.endsWith('/onboarding')

  if (isOnboardingPage || storedSource) {
    sessionStorage.removeItem(ONBOARDING_SOURCE_KEY)
    const source = (isOnboardingPage && querySource) || storedSource
    if (source) {
      return `/onboarding?source=${encodeURIComponent(source)}`
    }
    return '/onboarding'
  }

  return '/auth/login'
}
